import React, { useEffect, useState } from "react";
import {
  StyleSheet,
  Platform,
  useWindowDimensions,
  View
} from "react-native";
import { SafeAreaView } from 'react-native-safe-area-context';
import StarRating from "react-native-star-rating-widget";
import { Rating, AirbnbRating } from 'react-native-ratings';
import { RadioButton } from "react-native-paper";
import Slider from "@react-native-community/slider";
import { useTheme } from "@react-navigation/native";
import { useTranslation } from "react-i18next";
import CustomInput from "../../CustomInput/CustomInput";
import CustomDropDown from "../../CustomDropDown/CustomDropdown";
import CustomLabel from "../../CustomLabel/CustomLabel";
import CustomButton from "../../CustomButton/CustomButton";
import CustomDraggableBox from "../CustomDraggableBox/CustomDraggableBox";
import { ScrollView } from "react-native-gesture-handler";

const CustomQuestionLine = (props) => {
  const { colors } = useTheme();
  const { width, height } = useWindowDimensions();
  const styles = makeStyles(colors, width);
  const { t } = useTranslation();
  // * Create Array for 0 - 10 Scale 
  const scaleArr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10']
  const scaleNaArr = ['N/A', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10']
  // Each zone holds an array of box indices (stacked order)
  const agreedisagree = ['Strongly Disagree', 'Disagree', 'Neutral', 'Agree', 'Strongly Agree'];
  const questionLineTypeList = [
    { label: t("common:text"), value: "Text" },
    { label: t("common:Slider"), value: "Slider" },
    { label: t("common:Essay"), value: "Essay" },
    { label: t("common:Scale"), value: "Scale" },
    { label: t("common:ScaleNa"), value: "Scale With n/a" },
  ];

  //#region UseEffect
  useEffect(() => {
    // * No need to do anything here
  }, [width, height]);
  //#endregion

  // * Load value depending on question option id
  var respValue = 0;
  if (props.questionOptionResponseList) {
    props.questionOptionResponseList.map((qorItr) => {
      if (qorItr.question_option_id === question_option_id) {
        if (
          props.question_input_type_name === "Options" ||
          props.question_input_type_name === "True/False Options" ||
          props.question_input_type_name === "Rating Options"
        ) {
          respValue =
            qorItr.answer_yn === 0 || qorItr.answer_yn === 2 ? false : true;
        } else if (input_type_name === "Text") {
          respValue = qorItr.answer_text;
        } else if (
          props.question_input_type_name === "Slider" ||
          props.question_input_type_name === "Boxes" ||
          props.question_input_type_name === "Rating(10)" ||
          props.question_input_type_name === "Rating(5)"
        ) {
          respValue = qorItr.answer_numeric;
        }
      }
    });
  }

  //#region Helpers
  const DrawBoxResults = ({ lines }) => {
    {
      console.log(lines)
      return lines.map((itr, index) => (
        <SafeAreaView
          style={styles.rowflex}
          key={index}>
          <CustomLabel
            value={`→ ${itr.question_line_description} : `}
            type='BOXESRESULT'
          />
          <CustomLabel
            value={agreedisagree[itr.question_line_resp]}
            type='BOXESRESULTVALUE'
          />
        </SafeAreaView>
      ))
    }
  }
  //#endregion

  //* if nothing is selected in the Question drop down then show only a message and not Question Lines
  if (props.question_input_type_name === "") {
    return (
      <SafeAreaView style={styles.rowMax}>
        <CustomLabel value={t("common:selectQuestionType")} type="ASSM" />
      </SafeAreaView>)
  }
  return (
    <SafeAreaView style={styles.main}>
      {/* // * Create Assessment */}
      {props.toView === 0 && (
        <SafeAreaView style={styles.rowflex}>
          {props.question_input_type_name === 'TCC' && (
            <SafeAreaView style={styles.dropDownView}>
              <CustomDropDown
                disabled={props.Editable ? false : true}
                defValue={props.singleQuestionLine.input_type_name}
                options={questionLineTypeList}
                value={props.singleQuestionLine.input_type_name}
                setValue={(type) => props.handleQuestionLineChange('', type, '', 0, 0, 0, props.sectionIndex, props.questionIndex, props.index)}
                type="FULL"
              />

            </SafeAreaView>
          )}
          <SafeAreaView style={styles.FiftyWidth}>
            <CustomInput
              value={props.questionLineName === "" ? "" : props.questionLineName}
              editable={props.toView == 1 || props.Editable === 0 ? false : true}
              setValue={(desc) => props.handleQuestionLineChange(desc, '', '', 0, 0, 0, props.sectionIndex, props.questionIndex, props.index)}
              type="SURVEYHEADER2"
              placeholder={
                props.questionLineName === "" || props.questionLineName === undefined
                  ? "Write Question Line Description"
                  : props.questionLineName
              }
            />
          </SafeAreaView>

          {props.Editable ?
            <SafeAreaView >
              <CustomButton
                text={Platform.OS === "web" && width > 1300 ? t("common:addQuestionLine") : ""}
                onPress={() => props.handleQuestionLineAdd(props.index, props.sectionIndex, props.questionIndex)}
                iconName="add-outline"
                show="ASSM"
                type="ASSM"
                isGradient={true}
                textTop="0"
                sz={25}
              />
            </SafeAreaView>
            : <></>
          }
        </SafeAreaView>
      )}

      {/* // * Complete Assessment */}
      <SafeAreaView
        style={styles.mainAligh}>
        {props.singleQuestionLine?.question_line_control === "textbox" && props.toView &&
          <SafeAreaView
            style={styles.rowflex}>
            <CustomLabel
              value={props.questionLineName}
              type='ASSMRESP'
            />
            <SafeAreaView style={styles.FiftyWidth}>
              <CustomInput
                value={props.singleQuestionLine.question_line_resp === "" || props.singleQuestionLine.question_line_resp === 0 ? "" : props.singleQuestionLine.question_line_resp}
                editable={props.assm_submitted !== undefined ? !props.assm_submitted : true}
                setValue={(resp) => props.handleQuestionLineResp(resp, props.question_line_respUI, props.sectiond_id, props.questionId)}
                type='ASSMLINE'
                placeholder={t("common:responsePlaceholder")}
              />
            </SafeAreaView>
          </SafeAreaView>
        }
        {props.singleQuestionLine?.question_line_control === "Essay" && props.toView &&
          <SafeAreaView
            style={styles.rowflex}>
            <CustomLabel
              value={props.questionLineName}
              type='ASSMRESP'
            />
            <SafeAreaView style={styles.FiftyWidth}>
              <CustomInput
                value={props.singleQuestionLine.question_line_resp === "" || props.singleQuestionLine.question_line_resp === 0 ? "" : props.singleQuestionLine.question_line_resp}
                editable={props.assm_submitted !== undefined ? !props.assm_submitted : true}
                setValue={(resp) => props.handleQuestionLineResp(resp, props.question_line_respUI, props.sectiond_id, props.questionId)}
                type='ASSMLINE'
                placeholder={props.singleQuestionLine.question_line_resp === "" ? t("common:responsePlaceholder") : props.singleQuestionLine.question_line_resp}
              />
            </SafeAreaView>
          </SafeAreaView>
        }
        {props.singleQuestionLine?.question_line_control === "slider" && props.toView &&
          <SafeAreaView
            style={styles.rowflex}>
            <CustomLabel
              value={props.questionLineName}
              type='ASSMRESP'
            />
            <SafeAreaView style={styles.FiftyWidth}>
              <CustomLabel
                value={props.singleQuestionLine.question_line_resp === "" || props.singleQuestionLine.question_line_resp === 0 ? 0 : props.singleQuestionLine.question_line_resp}
                type='ASSMRESPLABEL'
              />
              <Slider
                style={{ flex: 1, }}
                step={1}
                value={parseInt(props.singleQuestionLine.question_line_resp)}
                minimumValue={0}
                maximumValue={10}
                disabled={props.assm_submitted !== undefined ? props.assm_submitted : false}
                onValueChange={(resp) => props.handleQuestionLineResp(resp.toString(), props.question_line_respUI, props.sectiond_id, props.questionId)}
                minimumTrackTintColor={colors.buttons_primary}
                maximumTrackTintColor="#000000"
              />
            </SafeAreaView>
          </SafeAreaView>
        }
        {props.quest_controls === "boxes" && props.toView &&
          <SafeAreaView
            style={styles.columnBox}>
            <CustomLabel
              value={t("common:dragQuestion")}
              type='ASSMMINORBOX'
            />

            {!props.isResult ?
              <SafeAreaView>
                <CustomDraggableBox
                  questionLines={props.questionLines}
                  sectiond_id={props.sectiond_id}
                  questionId={props.questionId}
                  handleQuestionLineResp={props.handleQuestionLineResp}
                  isSubmitted={props.assm_submitted !== undefined ? props.assm_submitted : false}
                  agreedisagree={agreedisagree}
                />
                {props.questionLines1 !== undefined && <SafeAreaView>
                  <CustomLabel
                    value={t("common:previewAppraisee")}
                    type='ASSMRESP'
                  /><DrawBoxResults lines={props.questionLines1} /> </SafeAreaView>}
                {props.questionLines2 !== undefined && <SafeAreaView>
                  <CustomLabel
                    value={t("common:previewAppraiser")}
                    type='ASSMRESP'
                  /><DrawBoxResults lines={props.questionLines2} /> </SafeAreaView>}
              </SafeAreaView> :
              <SafeAreaView
                style={styles.columnBoxesResult}>
                <DrawBoxResults lines={props.questionLines} />
              </SafeAreaView>
            }
          </SafeAreaView>
        }

        {(props.singleQuestionLine?.question_line_control === "Scale" || (props.singleQuestionLine?.question_line_control === "Scale With n/a")) && props.toView &&
          <SafeAreaView>
            <SafeAreaView
              style={styles.rowflex}>
              <CustomLabel
                value={props.questionLineName}
                type='ASSMRESP'
              />
              <ScrollView>
                <RadioButton.Group
                  onValueChange={(resp) => props.handleQuestionLineResp(resp, props.question_line_respUI, props.sectiond_id, props.questionId)}
                  value={props.singleQuestionLine.question_line_resp}>
                  <SafeAreaView>
                    {props.singleQuestionLine?.question_line_control === "Scale" ?
                      <SafeAreaView style={styles.radioDirection}>
                        {scaleArr.map((sItr) =>
                          <SafeAreaView
                            style={styles.radioButton}>
                            <CustomLabel
                              value={sItr}
                              type='ASSMLINE' />

                            <RadioButton
                              disabled={props.assm_submitted !== undefined ? props.assm_submitted : false}
                              value={sItr}
                            />
                          </SafeAreaView>
                        )} </SafeAreaView>
                      : <SafeAreaView style={styles.radioDirection}>
                        {scaleNaArr.map((sItr) =>
                          <SafeAreaView
                            style={styles.radioButton}>
                            <CustomLabel
                              value={sItr}
                              type='ASSMLINE' />

                            <RadioButton
                              disabled={props.assm_submitted !== undefined ? props.assm_submitted : false}
                              value={sItr}
                            />
                          </SafeAreaView>
                        )} </SafeAreaView>
                    }
                  </SafeAreaView>
                </RadioButton.Group>
              </ScrollView>
            </SafeAreaView>
            {/* // * Preview Appraisee */}
            {props.singleQuestionLineStage1 !== undefined &&
              <SafeAreaView
                style={styles.rowflex}>
                <CustomLabel
                  value={t("common:previewAppraisee")}
                  type='ASSMRESP'
                />
                <ScrollView>
                  <RadioButton.Group
                    value={props.singleQuestionLineStage1?.question_line_resp}>
                    <SafeAreaView>
                      {props.singleQuestionLine?.question_line_control === "Scale" ?
                        <SafeAreaView style={styles.radioDirection}>
                          {scaleArr.map((sItr) =>
                            <SafeAreaView
                              style={styles.radioButton}>
                              <CustomLabel
                                value={sItr}
                                type='ASSMLINE' />

                              <RadioButton
                                disabled={props.assm_submitted !== undefined ? props.assm_submitted : false}
                                value={sItr}
                              />
                            </SafeAreaView>
                          )} </SafeAreaView>
                        : <SafeAreaView style={styles.radioDirection}>
                          {scaleNaArr.map((sItr) =>
                            <SafeAreaView
                              style={styles.radioButton}>
                              <CustomLabel
                                value={sItr}
                                type='ASSMLINE' />

                              <RadioButton
                                disabled={props.assm_submitted !== undefined ? props.assm_submitted : false}
                                value={sItr}
                              />
                            </SafeAreaView>
                          )} </SafeAreaView>
                      }
                    </SafeAreaView>
                  </RadioButton.Group>
                </ScrollView>
              </SafeAreaView>
            }
            {/* //* Preview Appraiser */}
            {props.singleQuestionLineStage2 !== undefined &&
              <SafeAreaView
                style={styles.rowflex}>
                <CustomLabel
                  value={t("common:previewAppraiser")}
                  type='ASSMRESP'
                />
                <ScrollView>
                  <RadioButton.Group
                    value={props.singleQuestionLineStage2?.question_line_resp}>
                    <SafeAreaView>
                      {props.singleQuestionLine?.question_line_control === "Scale" ?
                        <SafeAreaView style={styles.radioDirection}>
                          {scaleArr.map((sItr) =>
                            <SafeAreaView
                              style={styles.radioButton}>
                              <CustomLabel
                                value={sItr}
                                type='ASSMLINE' />

                              <RadioButton
                                disabled={props.assm_submitted !== undefined ? props.assm_submitted : false}
                                value={sItr}
                              />
                            </SafeAreaView>
                          )} </SafeAreaView>
                        : <SafeAreaView style={styles.radioDirection}>
                          {scaleNaArr.map((sItr) =>
                            <SafeAreaView
                              style={styles.radioButton}>
                              <CustomLabel
                                value={sItr}
                                type='ASSMLINE' />

                              <RadioButton
                                disabled={props.assm_submitted !== undefined ? props.assm_submitted : false}
                                value={sItr}
                              />
                            </SafeAreaView>
                          )} </SafeAreaView>
                      }
                    </SafeAreaView>
                  </RadioButton.Group>
                </ScrollView>
              </SafeAreaView>}
            <View style={styles.line} />
          </SafeAreaView>
        }
      </SafeAreaView>
    </SafeAreaView>
  );
};

const makeStyles = (colors, width) =>
  StyleSheet.create({
    main: {
      width: '100%',
      alignItems: "center",
    },
    mainAligh: {
      width: '100%',
      justifyContent: 'center',
      alignItems: 'center',
      margin: 30,
      paddingStart: 10,
    },
    row: {
      width: Platform.OS === "web" && width > 1300 ? width / 3 : "80%",
      margin: 10,
      flexWrap: "wrap",
      flexDirection: "row",
    },
    dropDownView: {
      flex: 1,
      alignSelf: "center",
      justifyContent: "center",
    },
    rowMax: {
      width: Platform.OS === "web" && width > 1300 ? "100%" : "80%",
      margin: 10,
      flex: 1,
      flexWrap: "wrap",
      alignContent: "center",
      flexDirection: "row",
    },
    rowflex: {
      width: '100%',
      flexDirection: 'row',
      margin: 10,
    },
    column: {
      width: '100%',
      flex: 1,
      backgroundColor: 'pink',
      marginHorizontal: 20,
    },
    columnBox: {
      width: '100%',
      flexGrow: 1,
      marginHorizontal: 20,
    },
    twentyFiveWidth: {
      width: "25%",
    },
    FiftyWidth: {
      width: "50%",
    },
    radioDirection: {
      width: '100%',
      justifyContent: 'center',
      flexDirection: (Platform.OS === 'web' && width > 1300) ? 'row' : 'column'
    },
    radioButton: {
      flex: 1,
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: (Platform.OS === 'web' && width > 1300) ? 'column' : 'row'
    },
    line: {
      borderBottomColor: colors.buttons_primary,
      borderBottomWidth: StyleSheet.hairlineWidth,
      marginTop: "1%",
      marginBottom: "1%",
    },
  });

export default CustomQuestionLine;
